import { Experiment } from '@/consts/LDFlags';
import { Address } from '@/models';

export type NormalizedAddress = {
  city?: string;
  country?: string;
  country_code?: string;
  postal_code?: string;
  region?: string;
  state_code?: string;
  street?: string;
  zip?: string;
};

export const normalizeAddress = (address?: Address | null): NormalizedAddress | undefined => {
  if (!address) {
    return undefined;
  }

  // TODO add country_code to address schema and API input
  const country = address.country?.toUpperCase();
  const zip = address.zip?.replace(/[^\d]/g, '').slice(0, 5);
  const stateCode = address.state_code?.toUpperCase();

  return {
    city: address.city?.toLowerCase(),
    country: country === 'UNITED STATES' ? 'US' : country,
    country_code: country === 'UNITED STATES' ? 'US' : country,
    postal_code: zip,
    region: stateCode,
    state_code: stateCode,
    street: address.street?.toLowerCase().replace(/[\s]/g, ''),
    zip,
  };
};

export const normalizePhone = (phone?: string | null): string | undefined => {
  if (!phone) {
    return undefined;
  }

  const cleanedPhone = phone.replace(/\D/g, '');

  if (cleanedPhone.length < 10) {
    return cleanedPhone;
  }

  if (/^\d{10}$/.test(cleanedPhone)) {
    return `+1${cleanedPhone}`;
  }

  return `+${cleanedPhone}`;
};

export const normalizeEmail = (email?: string | null): string | undefined => {
  return email?.toLowerCase().replace(/\s/g, '') || undefined;
};

// DataDog can't facet an array of objects (`usr.experiments.name` collapses to one value per event);
// key by experiment name instead so each experiment gets its own indexable attribute.
export const normalizeExperiments = (experiments?: Experiment[]): Record<string, string> | undefined => {
  if (!experiments?.length) {
    return undefined;
  }

  return Object.fromEntries(experiments.map(({ name, variation }) => [name, variation]));
};
